export default "__VITE_ASSET__COCg91lS__"